module.exports = __webpack_public_path__ + "img/3.29d206c4.png";